<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               @click="showModal(showAddTransactionNumber)"
               :disabled="disabled"
               v-tooltip="tooltip">
      ADD TRANSACTION NUMBER
    </ed-button>
    <ed-modal title="Add Transaction Number" :show="showAddTransactionNumber" @close='showModal(showAddTransactionNumber)' @confirm='saveTransactionNumber' primary-button="ADD" secondary-button="CLOSE">
      <div slot="body" class='add-transaction-number-overlay'>
        <p class="small">Provide the transaction number from your accounting software. This information will be added to envelopes in this AP File</p>
        <label>AP File</label>
        <br />
        <div v-if="selectedRows.length" v-for="(row, i) in selectedRows" :key="i">
          <div><small>{{ row.data.APFile }}</small></div>
        </div>
        <br />
        <label>Transaction Number</label>
        <div class="form-group">
          <ed-input v-model='transactionNumber'
                    placeholder="Transaction Number"
                    class="full-width">
          </ed-input>
        </div>
      </div>
    </ed-modal>
  </span>
</template>

<script>
  export default {
    props: {
      selectedRows: [],
      disabled: false,
      tooltip: ''
    },

    data() {
      return {
        showAddTransactionNumber: false,
        transactionNumber: ''
      }
    },

    created() {
    },

    methods: {
      async saveTransactionNumber() {
        const ids = this.selectedRows.map(row => row.data.Id)

        try {
          const response = await this.api.post(this.api.$.evedpaycard.addTransactionNumberToEnvelope, {
            ids: ids,
            transactionNumber: this.transactionNumber
          })

          if (response.status === 200) {
            this.$emit('success')
          } else {
            alert('Error saving transaction number.')
          }
        } catch (error) {
          console.error('Error saving transaction number:', error)
        }
      },

      showModal(showAddTransactionNumber) {
        this.showAddTransactionNumber = !showAddTransactionNumber
        if (!showAddTransactionNumber) {
          this.resetModal()
        }
      },

      resetModal() {
        this.transactionNumber = ''
      }
    }
  }
</script>

<style lang='scss' scoped>
  .add-transaction-number-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/AddTransactionNumber.vue